import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import useFileUploader from './useFileUploader';

export interface FileType extends File {
  preview?: string;
  formattedSize?: string;
}

interface FileUploaderProps extends ChildrenProps {
  onFileUpload?: (files: FileType[]) => void;
  showPreview?: boolean;
  isImageOnly?: boolean;
}

type ChildrenProps = {
  isSingleFile?: boolean;
  icon?: string;
  text?: string;
  textClass?: string;
  extraText?: string
}

const FileUploader = ({ showPreview = true, onFileUpload, isImageOnly, icon, extraText, text, isSingleFile }: FileUploaderProps) => {
  const { selectedFiles, handleAcceptedFiles, removeFile } = useFileUploader(showPreview);

  // accept değerini yalnızca image dosyalarını kabul edecek
  const acceptTypes = isImageOnly ? { 
    'image/png': ['.png'],
    'image/jpg': ['.jpg'],
    'image/jpeg': ['.jpeg'],
   } : undefined;

  return (
    <>
      <Dropzone
        onDrop={(acceptedFiles) => handleAcceptedFiles(acceptedFiles, onFileUpload)}
        accept={acceptTypes}
        maxFiles={isSingleFile ? 1 : undefined} // Sadece tek dosya seçimine izin veriyoruz
      >
        {({ getRootProps, getInputProps }) => (
          <div className="dropzone bg-white flex justify-center items-center dark:bg-gray-800 rounded-md border-2 border-dashed border-gray-200 dark:border-gray-700 min-h-[130px]">
            <div className="dz-message needsclick flex items-center flex-col" {...getRootProps()}>
              <input {...getInputProps()} />
              <img width="36" height="41" src="/images/upload.png" />
              <h4 className="h4">{text}</h4>
              <span className="text-muted fs-13">{extraText}</span>
            </div>
          </div>
        )}
      </Dropzone>

      {showPreview && selectedFiles.length > 0 && (
        <div className="dropzone-previews mt-3">
          {(selectedFiles || []).map((file, idx) => (
            <div className="mt-1 mb-0 shadow-none border rounded" key={idx + '-file'}>
              <div className="p-2">
                <div className="flex items-center justify-between gap-2 w-full">
                  <div className='flex items-center gap-2 overflow-hidden'>
                    {file.preview && (
                      <div>
                        <div className="h-12 w-12">
                          <img
                            data-dz-thumbnail=""
                            className="w-full h-full rounded object-cover"
                            alt={file.name}
                            src={file.preview}
                          />
                        </div>
                      </div>
                    )}
                    {!file.preview && (
                      <div className="">
                        <div className="avatar-sm">
                          <span className="avatar-title bg-primary rounded">
                            {file.type.split('/')[0]}
                          </span>
                        </div>
                      </div>
                    )}
                    <div className="ps-0 overflow-hidden">
                      <Link to="#" className="text-muted fw-bold truncate">
                        {file.name}
                      </Link>
                      <p className="mb-0">
                        <strong>{file.formattedSize}</strong>
                      </p>
                    </div>
                  </div>
                  <div className="text-end">
                    <Link to="#" className="p-3 text-muted shadow-none">
                      <i className="mgc_close_line text-base" onClick={() => removeFile(file)} />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
};

export default FileUploader;
